export default class ArrayUtil {
    /**
     * Gets the unique values from an array. Works best on primitives and objects.
     */
    public static Unique<T>(array: Array<T>): Array<T> {
        // This was made much easier with ES6
        // https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
        return Array.from(new Set(array));
    }
}



// WEBPACK FOOTER //
// ./src/utils/ArrayUtil.ts